import { render, staticRenderFns } from "./QServHouseComp.vue?vue&type=template&id=66de4478&"
import script from "./QServHouseComp.vue?vue&type=script&lang=js&"
export * from "./QServHouseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports